var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopularityIcon = function SvgPopularityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#popularity-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.78 14.173.353.353za1.164 1.164 0 0 0 0 1.648l4.393 4.393a1.164 1.164 0 0 0 1.647 0l4.393-4.393a1.164 1.164 0 1 0-1.647-1.648l-2.4 2.4v-6.24c0-.642-.523-1.166-1.166-1.166s-1.167.524-1.167 1.167v6.24l-2.4-2.4a1.17 1.17 0 0 0-1.653 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "popularity-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPopularityIcon;